export const SELECT_CURRENCY = 'SELECT_CURRENCY'
export const SWITCH_CURRENCIES = 'SWITCH_CURRENCIES'
export const TYPE_INPUT = 'TYPE_INPUT'

// saga
export const POST_EXCHANGE = 'POST_EXCHANGE'
